import React from "react";
import { useParams } from "react-router-dom";
import useFileDocuments from "../actions/useFileDocuments";
import Folders from "./Folders";
import FolderSkeleton from "./FolderSkeleton";

const EntityDocuments = () => {
  const { id } = useParams();
  const { states, handleClickService } = useFileDocuments({ id });

  return (
    <div className="folders-container">
      {states?.folders?.length > 0 && (
        <p className="document-sub-heading"> Folders</p>
      )}
      {states.loading ? (
        <FolderSkeleton />
      ) : (
        <Folders folders={states?.folders} onFolderClick={handleClickService} />
      )}
    </div>
  );
};

export default EntityDocuments;
